const reviews = [
  { name: 'Elnur Həsənov', role: 'Mühasib', text: 'emailaze sayəsində korporativ emaillərimiz artıq tam təhlükəsizdir. İnterfeys çox rahat və sürətlidir.' },
  { name: 'Aytən Məmmədova', role: 'Hüquqşünas', text: 'Üç dil dəstəyi bizim kimi çoxdilli komandalar üçün mükəmməldir. Keçid çox asan oldu.' },
  { name: 'Rauf Əliyev', role: 'Sahibkar', text: 'Mail.net.az-dan keçdim — fərq gecə ilə gündüz kimi. emailaze həqiqətən müasir platformadır.' },
  { name: 'Nigar Quliyeva', role: 'Mühəndis', text: 'Spam filtri inanılmaz işləyir. Artıq gərəksiz emaillər almıram. Tövsiyə edirəm.' },
  { name: 'Kamran Babayev', role: 'Müəllim', text: 'Qeydiyyat 2 dəqiqə çəkdi. Hər şey intuitivdir, heç bir konfiqurasiya lazım olmadı.' },
  { name: 'Leyla İsmayılova', role: 'Həkim', text: 'Tibb sahəsindəyik — məlumat məxfiliyi bizim üçün kritikdir. emailaze bu standartı tam qarşılayır.' },
];

export default function TestimonialsSection() {
  const { t } = useTranslation();
  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block bg-primary-50 text-primary-600 text-xs font-semibold px-3 py-1 rounded-full tracking-wide uppercase mb-4">{t('home.reviews_badge')}</span>
          <h2 className="font-display text-4xl sm:text-5xl font-bold text-slate-900">{t('home.reviews_title')}</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <div key={i} className="bg-white rounded-2xl p-6 border border-slate-100 shadow-sm hover:shadow-md transition-shadow">
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, j) => (
                  <svg key={j} className="w-4 h-4 text-amber-400" fill="currentColor" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>
                ))}
              </div>
              <p className="text-slate-600 text-sm leading-relaxed mb-4">"{r.text}"</p>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 font-bold text-sm">{r.name[0]}</div>
                <div>
                  <div className="text-sm font-semibold text-slate-900">{r.name}</div>
                  <div className="text-xs text-slate-400">{r.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
